export default __webpack_public_path__ + "static/media/times-white.1650572f.svg";